import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'

import './style.scss'

export default class Column extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, IPropTypes.list, PropTypes.element]).isRequired,
    }

    render() {
        const { children } = this.props

        return <div className={'buttons-array-column'}>{children}</div>
    }
}
